import { render, staticRenderFns } from "./Box13.vue?vue&type=template&id=7542acb8&scoped=true&"
import script from "./Box13.vue?vue&type=script&lang=js&"
export * from "./Box13.vue?vue&type=script&lang=js&"
import style0 from "./Box13.vue?vue&type=style&index=0&id=7542acb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../src/h5-coursePage/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7542acb8",
  null
  
)

export default component.exports